import { Component, OnInit } from '@angular/core';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { CorporationZoneService } from '../corporation-zone.service';
import { HttpService } from 'src/app/http.service';
import { GlobalService } from 'src/app/global.service';

@Component({
  selector: 'app-corporation-zone-register',
  templateUrl: './corporation-zone-register.component.html',
  styleUrls: ['./corporation-zone-register.component.scss']
})
export class CorporationZoneRegisterComponent implements OnInit {
  corporation_zone_register_from: FormGroup;
  action: string = '';
  constructor(private formBuilder: FormBuilder, private service: CorporationZoneService, private http: HttpService, private global: GlobalService) {
    this.corporation_zone_register_from = this.formBuilder.group({
      id: [null, Validators.compose([])],
      corporation_zone_name: [null, Validators.compose([Validators.required])],
    })

    if (this.service.get_corporation_zone_data === null) {
      this.action = 'register';
    } else {
      this.action = 'update';
      this.setupUpdateForm(this.service.get_corporation_zone_data);
    }


    this.service.CorporationZoneUpdate.subscribe((corp_zone) => {
      if (corp_zone === null) {
        this.action = 'register';
        this.corporation_zone_register_from.reset();
      } else {
        this.action = 'update';
        this.setupUpdateForm(corp_zone);
      }
    });

    this.service.CorporationZoneUpdate.subscribe((relation_type) => {
      this.setupUpdateForm(relation_type);
    });

  }

  setupUpdateForm(data) {
    this.corporation_zone_register_from.controls['id'].setValue(data['id']);
    this.corporation_zone_register_from.controls['corporation_zone_name'].setValue(data['name']);
  }

  registerCorporationZone() {
    const relation_type_data = Object.assign({}, this.corporation_zone_register_from.value);
    console.log(relation_type_data)
    this.http.registerCorporationZone(relation_type_data).subscribe((data: string) => {
      this.service.downloadCorporationZone.emit(true);
      this.global.showSnakeBar(data['message']);
    });
  }
  ngOnInit() {
  }

}
